import UIFacade from "@baseUI/UIFacade";
import UIMainContainer from "@baseUI/views/UIMainContainer";

export default class UIView {
    constructor() {
    }

    init(container, menuContainer, uiModelView) {
        UIFacade.menuContainer = menuContainer;
        this.uiModelView = uiModelView;

        this.mainContainer = new UIMainContainer(uiModelView);
        this.mainContainer.interactive = false;
        container.addChild(this.mainContainer);
    }

    show() {
        this.mainContainer.show();
    }

    hide() {
        this.mainContainer.hide();
    }

    updateText() {
        this.mainContainer.updateText();
    }

    showPopup() {
        this.mainContainer.showPopup();
    }

    closePopup() {
        this.mainContainer.closePopup();
    }

    setButtonState(data) {
        this.mainContainer && this.mainContainer.setButtonState(data)
    }
}
